import { State, Effect, Actions, dispatch } from 'jumpstate'
import { showLoading, hideLoading } from 'react-redux-loading-bar'
import axios from 'axios'
import apiAddress from '../utils/APIEndPointAddress'

const MainState = State({
  initial: {
    horseCount: null,
    topHorses: null
  },
  setHorseCount (state, payload) {
    return {
      ...state,
      horseCount: payload
    }
  },
  setTopHorses (state, payload) {
    return {
      ...state,
      topHorses: payload
    }
  }
})

// eslint-disable-next-line
const getCountEffect = Effect('getCount', () => {
  axios.interceptors.request.use((config) => {
    dispatch(showLoading())
    return config
  })
  axios.interceptors.response.use((response) => {
    dispatch(hideLoading())
    return response
  }, (error) => {
    dispatch(hideLoading())
    return Promise.reject(error)
  })
  return axios.get(`${apiAddress}main/info`).then((res) => {
    Actions.setHorseCount(res.data.horseCount)
    return res.data
  })
})

// eslint-disable-next-line
const loadTopHorsesEffect = Effect('loadTopHorses', () => {
  axios.interceptors.request.use((config) => {
    dispatch(showLoading())
    return config
  })
  axios.interceptors.response.use((response) => {
    dispatch(hideLoading())
    return response
  }, (error) => {
    dispatch(hideLoading())
    return Promise.reject(error)
  })
  return axios.get(`${apiAddress}horse/top`).then((res) => {
    Actions.setTopHorses(res.data)
    return res.data
  })
})

// eslint-disable-next-line
const mainInfoEffect = Effect('mainInfo', () => {
  return Promise.resolve().then(() => {
    Actions.getCount()
  }).then(() => {
    Actions.loadTopHorses()
  }).catch((e) => { console.log(e); Promise.reject(e) })
})

export default MainState



// WEBPACK FOOTER //
// ./src/states/main.js